module.exports = __webpack_public_path__ + "static/media/filter-icon.58db9c2d.svg";